import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/login-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-03b4fa39"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  class: "section1",
  style: {}
}
const _hoisted_3 = {
  class: "section",
  style: {}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Aboitiz logo",
  src: _imports_0
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#2E3192"} }, "PAYMENT STATUS PORTAL", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "sub-title" }, "Vendor Change Password", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Change Password ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LockOutlined = _resolveComponent("LockOutlined")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_a_form, {
          id: "components-form-demo-normal-login",
          model: _ctx.userState,
          labelCol: { span: 30 },
          wrapperCol: { span: 25 },
          style: {"padding":"0 40px","margin-top":"40px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  id: "current_password",
                  value: _ctx.userState.current_password,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userState.current_password) = $event)),
                  autocomplete: "new-password",
                  placeholder: "Current Password",
                  class: "login-fields"
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_LockOutlined, { style: {"color":"rgba(0, 0, 0, 0.25)"} })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  id: "password",
                  value: _ctx.userState.password,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userState.password) = $event)),
                  autocomplete: "new-password",
                  placeholder: "New Password",
                  class: "login-fields"
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_LockOutlined, { style: {"color":"rgba(0, 0, 0, 0.25)"} })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  id: "password_confirmation",
                  value: _ctx.userState.password_confirmation,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userState.password_confirmation) = $event)),
                  autocomplete: "new-password",
                  placeholder: "Confirm Password",
                  class: "login-fields"
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_LockOutlined, { style: {"color":"rgba(0, 0, 0, 0.25)"} })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: "24" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          "html-type": "submit",
                          type: "primary",
                          class: "login-btn",
                          onClick: _ctx.handleFinish
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
}